import { Link } from 'react-router-dom';
import { getRankedGames } from '@/mocks/games';

export default function RankingSection() {
  const rankedGames = getRankedGames(10);

  return (
    <section className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold">
            黄游戏排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            根据玩家评分和热度综合排名
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {rankedGames.map((game, index) => (
            <Link
              key={game.id}
              to={`/article/${game.slug}`}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 cursor-pointer group"
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                {index < 3 ? (
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold text-background-50 ${
                      index === 0
                        ? 'bg-primary-500'
                        : index === 1
                          ? 'bg-accent-500'
                          : 'bg-secondary-500'
                    }`}
                  >
                    {index + 1}
                  </div>
                ) : (
                  <span className="text-sm font-bold text-foreground-400">
                    {index + 1}
                  </span>
                )}
              </div>

              <div className="w-14 h-14 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={game.thumbUrl}
                  alt={game.title}
                  title={game.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 font-bold group-hover:text-primary-600 transition-colors truncate whitespace-nowrap">
                  {game.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate whitespace-nowrap">
                  {game.category} · {game.developer}
                </p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1 text-xs">
                <i className="ri-star-fill text-primary-500"></i>
                <span className="font-semibold text-foreground-700">{game.rating}</span>
                <span className="text-foreground-400">
                  ({game.ratingCount > 10000 ? `${(game.ratingCount / 10000).toFixed(1)}万` : game.ratingCount})
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}